export default "__VITE_ASSET__CGdB3qke__"